import React from 'react';
import { Box, RadioGroup, FormControlLabel, FormControl, Radio } from '@material-ui/core';
import useStyles from 'components/WaterUser/Styles';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { toolbarHeight } from "components/app/Styles";
import { filterContainerHeight, chartTitleHeight } from "../common/Styles";
import { useSelector } from 'react-redux';
// import userActions from "../common/actions";
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';

const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
}

const IndustryShortage = () => {
    const classes = useStyles();
    const [windowSize, setWindowSize] = React.useState(getWindowSize());
    const { industry_shortage } = useSelector((state) => state.water_user);
    const [options, setOptions] = React.useState({});
    // const { loadIndustryShortages } = userActions();
    const [industryType, setIndustryType] = React.useState('powergen');
    const { isMobile } = useGetViewPortDimensions();
    
    const quantifier = {
        1: "K",
        2: "M",
        3: "B"
    };

    const handleChange = (event,value) => {
      setIndustryType(value);
    };

    //gets windowSize to set width of barchart
    React.useEffect(() => {
        const handleWindowResize = () => {
        setWindowSize(getWindowSize());
        };
        window.addEventListener("resize", handleWindowResize);
        return () => {
        window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    let labels = [];
    let series = [
      {
        name: 'Power Generation',
        data: [],
        color: '#2352D0'
      },
      {
          name: 'Mining',
          data: [],
          color: '#F3C745'
      }, 
    ];
    industry_shortage.map((shortage) => {
        let cnt = 0;
        let available = shortage.total_water;
        while (available >= 1000) {
            available /= 1000;
            cnt += 1
        }
        labels.push(available.toString() + quantifier[cnt]);
        series[1].data.push(Math.round(shortage.mining, 2));
        series[0].data.push(Math.round(shortage.power_generation,2 ));
        return shortage
    });

    const setHighChartOption = () => {
      setOptions({
        chart: {
          type: "column",
          backgroundColor: "#E5E9EE",
          width: isMobile ? 380 : windowSize.innerWidth - 500,
          height:
            windowSize.innerHeight -
            toolbarHeight -
            filterContainerHeight -
            chartTitleHeight -
            75 -
            //slider height
            66,
        },
        title: {
          text: undefined,
        },
        series: industryType==="powergen" ? series[0] : series[1] ,
        plotOptions: {
          column: {
            stacking: "normal",
            states: {
              hover: {
                enabled: false,
              },
              inactive: {
                opacity: 1,
              },
            },
            borderWidth: 0,
            events: {
              legendItemClick: function () {
                return false; // <== returning false will cancel the default action
              },
            },
          },
          series: {
            pointWidth: 100,
          },
        },
        // tooltip: {
        //     shared: true,
        //     padding: 18,
        //     useHTML: true,
        //     borderWidth: 0,
        //     borderRadius: 15,
        //     backgroundColor: "#FFF",
        //     style: {
        //         opacity: 1,
        //         border: "none",
        //         fontSize: 14,
        //         lineHeight: 1,
        //         borderRadius: 15,
        //         fontSize: 14,
        //         fontFamily: "Arial"
        //     },
        //     formatter: function() {
        //         const mining = this.points[0].y;
        //         const power_generation = this.points[1].y;
        //         let tooltip = "<div>";
        //         tooltip += `<div style="width: 250px"><div style="height: 12px; width: 12px; background: #F3C745; border-radius: 10px; margin-right: 10px; float: left; margin-top: 0px"></div><span style="font-size: 14px">Mining: ${mining.toLocaleString("en-US")} (acre-feet)</span></div><br/>`;
        //         tooltip += `<div style="width: 250px"><div style="height: 12px; width: 12px; background: #2352D0; border-radius: 10px; margin-right: 10px; float: left; margin-top: 0px"></div><span style="font-size: 14px">Power Generation: ${power_generation.toLocaleString("en-US")} (acre-feet)</span></div>`;
        //         tooltip += '</div>';
        //         return tooltip;
        //     }
        // },
        credits: {
          enabled: false,
        },
        xAxis: {
          title: {
            text: "Colorado River Water Available (acre-feet)",
            style: {
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: "16px",
              },
          },
          categories: labels,
          labels: {
            style: {
              fontFamily: "Arial",
              fontWeight: "bold",
              fontSize: "16px",
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Colorado River Allocation (acre-feet)",
            margin: 40,
            style: {
              fontFamily: "Arial",
              fontWeight: "bold",
              fontSize: "16px",
            },
          },
          labels: {
            style: {
              fontFamily: "Arial",
              fontWeight: "bold",
              fontSize: "14px",
            },
          },
          gridLineWidth: 1,
          gridLineColor: "#C4C4C4",
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          enabled: false,
          title: {
            // text: "<span style='font-size:12px; color:#666; font-weight:normal font-family:Arial'>Legend</span>",
            // style: {
            //   fontStyle: "normal",
            // },
          },
          itemStyle: {
            color: "#333333",
            fontSize: "12px",
            fontWeight: "normal",
            fontFamily: "Arial",
          },
          align: "center",
          x: 50,
          backgroundColor: "#FFFFFF",
          borderColor: "#E0E0E0",
          borderWidth: 1,
          borderRadius: 15,
          padding: 10,
          itemMarginTop: 5,
          itemMarginBottom: 5,
          shadow: {
            offsetX: -1,
            offsetY: 3,
            color: "#00000029",
            width: 4,
          },
        },
      });
    }

    React.useEffect(setHighChartOption, [industryType, industry_shortage]);

    

    return (
    <Box className={classes.chartContainer}>

        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            className={classes.industryRadioGroup}
            value={industryType}
            onChange={handleChange}
          >
            <FormControlLabel value="powergen" control={<Radio color="primary" />} label="Power Generation" />
            <FormControlLabel value="mining" control={<Radio color="primary" />} label="Mining" />   
          </RadioGroup>
        </FormControl>

        <HighchartsReact highcharts={Highcharts} options={options}  />
    </Box>
    );

}

export default IndustryShortage;